import type { ReactNode } from "react";
import { useAuth } from "./auth-context";

/**
 * Hides UI the user cannot use.
 *
 * This is a usability control, NOT a security control. Every permission is
 * re-checked server-side on the endpoint itself — a user who edits their
 * token or calls the API directly gains nothing by defeating this component.
 */
export function RequirePermission({
  permission,
  anyOf,
  fallback = null,
  children,
}: {
  permission?: string;
  anyOf?: string[];
  fallback?: ReactNode;
  children: ReactNode;
}) {
  const { can, canAny } = useAuth();

  const allowed = permission
    ? can(permission)
    : anyOf
      ? canAny(...anyOf)
      : true;

  return <>{allowed ? children : fallback}</>;
}
